/**
 * Email domain validation for work email gating.
 * Personal/free email providers are blocked — Restack requires work email.
 */

const FREE_EMAIL_DOMAINS = new Set([
  // Google
  'gmail.com', 'googlemail.com',
  // Microsoft
  'hotmail.com', 'hotmail.co.uk', 'hotmail.fr', 'hotmail.de', 'hotmail.it',
  'outlook.com', 'outlook.co.uk', 'live.com', 'live.co.uk', 'msn.com',
  // Yahoo
  'yahoo.com', 'yahoo.co.uk', 'yahoo.fr', 'yahoo.de', 'yahoo.it',
  'yahoo.co.jp', 'yahoo.co.in', 'ymail.com', 'rocketmail.com',
  // Apple
  'icloud.com', 'me.com', 'mac.com',
  // Privacy / Encrypted
  'protonmail.com', 'proton.me', 'tutanota.com', 'tutamail.com',
  // AOL / Verizon
  'aol.com', 'aim.com',
  // Other major free providers
  'mail.com', 'email.com', 'zoho.com', 'zohomail.com',
  'yandex.com', 'yandex.ru',
  'gmx.com', 'gmx.de', 'gmx.net',
  'fastmail.com', 'fastmail.fm',
  'mail.ru', 'inbox.ru', 'list.ru', 'bk.ru',
  'qq.com', '163.com', '126.com', 'sina.com',
  'naver.com', 'hanmail.net', 'daum.net',
  'web.de', 'freenet.de', 't-online.de',
  'libero.it', 'virgilio.it',
  'laposte.net', 'orange.fr', 'free.fr',
  'rediffmail.com',
]);

export function isWorkEmail(email) {
  if (!email || typeof email !== 'string') return false;
  const domain = email.split('@')[1]?.toLowerCase();
  if (!domain) return false;
  return !FREE_EMAIL_DOMAINS.has(domain);
}

export function isPersonalEmail(email) {
  if (!email || typeof email !== 'string') return false;
  const domain = email.split('@')[1]?.toLowerCase();
  if (!domain) return false;
  return FREE_EMAIL_DOMAINS.has(domain);
}

export { FREE_EMAIL_DOMAINS };
